{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "בחר פריט",
  "tableResizer": "שינוי גודל",
  "colorSwatchPicker": "Color swatches"
}
